module.exports = __webpack_public_path__ + "static/media/1001320MF.8ebf3aed.jpg";